import { Button, Paper, Typography } from '@mui/material';
import { styled } from "@mui/material/styles";
import * as React from 'react';
import { useSelector } from 'react-redux';
import {  useTheme, Box, Stack } from '@mui/material';
import i18n from '../../i18n';
import { ApplicationState } from '../../store';
import errorImage from '../../assets/errorZ.svg';
import Helpers from '../helpers/Helpers';
import { useNavigate } from "react-router-dom";



const ZoomMeetingLimit = (props: any) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const userData = useSelector((state: ApplicationState) => state.appData);
    const appLanguage = useSelector((state: ApplicationState) => state.appData?.app4legalData?.lang);
    i18n.changeLanguage(localStorage.getItem("lang"));
    return (
        <Box
            sx={{
                [theme.breakpoints.down('sm')]: {
                    width: '100%',
                },
                [theme.breakpoints.up('sm')]: {
                    width: 'fit-content',
                //    maxWidth: '365px',
                },
                paddingBottom: '10px',
                overflow: 'hidden',
                borderRadius: '5px',
                display: 'flex',
                flexDirection: 'column',
                m: 'auto',
                width: 'fit-content',
                backgroundColor: '#fff',
                padding: 'initial',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
            <Stack sx={{ p: 2 }} spacing={2} alignItems="center">
                <div style={{
                    backgroundColor: "white",
                    width: '100%',
                    padding: '10px',
                    display: 'flex',
                    justifyContent: 'center'
                }}>
                    <img src={errorImage} style={{ width: '180px', height: '180px' }} />
                </div>
                <Typography variant="h6" textAlign="center" >Error</Typography>
                <Typography textAlign="center"> Error
                    {i18n.t('app.limitAlertMessage')}</Typography>
                <Button variant="contained" color="primary" onClick={
                    (event) => {
                        //revoke access token
                        Helpers.deleteZoomTokens();
                        Helpers.revokeZoomToken({ "access_token": userData?.tokens });
                       // Helpers.deleteZoomTokens();
                        navigate("/log_out");
                        if (window.location.pathname != "/end") {
                            Helpers.deleteZoomTokens();
                        //    setTimeout(() => { window.location.reload() }, 2000);
                        }
                    }}>
                    {i18n.t('app.logout')}
                </Button>
            </Stack>
        </Box>
    );
};
export default ZoomMeetingLimit;

